// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".password-recovery{width:100%;display:flex;flex-direction:column;padding-top:356px}.password-recovery h1{margin-bottom:36px;color:var(--color-dark-blue)}.password-recovery-text{margin-bottom:26px}.password-recovery-radio .v-icon{color:var(--color-default)}.password-recovery-radio .v-label{margin-left:10px;color:var(--font-color)!important}.password-recovery-step{min-width:540px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
